import { type TimelineState, initialTimelineState } from "./timeline/TimelineState";

export interface ViewState {
	timeline: TimelineState;
}

export const initialViewState: ViewState = {
	timeline: initialTimelineState,
};
